// For Custom Javascript

// Cart Quantity Change


jQuery(function() {
  var $holder = $('.carousel-holder ul')
  
  function setCarouselHolderDims () {    
    var $items = $holder.find('li:lt(6)')
    var height = 'auto'
    
    if ( window.innerWidth >= 769 && $holder.find('li').length > 6 ) {
      height = 0
      $items.each(function () {
        height += $(this).find('img').outerHeight(true)
      })
    }

    $holder.outerHeight(height)
    $holder.toggleClass('is-scrollable', $holder[0].scrollHeight > $holder[0].clientHeight)
  }

  setCarouselHolderDims()
  $(window).on('resize', setCarouselHolderDims)

  $('.js-carousel-more').on('click', function () {
    $holder.animate({
      scrollTop: $holder.scrollTop() + $holder[0].clientHeight
    })
  })
  
  $(".carousel-image").click(function( e, reset=true ) {
    var $this = $(e.currentTarget),
        index = $this.parent().index();
    
    $('.main-images__image')
      .eq(index)
      .addClass('is-active')
      .siblings()
      .removeClass('is-active')

    if ( reset )
      $('.main-images__image')
      .eq(index)
      .find('img:not(:last-child)').remove()
        
    return false
  })

  $(document).on('click', '.mw-product-options [data-value-id]', function () {
    $(".carousel-image").first().trigger('click', false)
    $(window).trigger('resize')
  })
})

jQuery(function() {
  return $("#description-toggle").click(function() {
    $(this).addClass('active');
    $("#material-toggle").removeClass('active');
    $("#size-toggle").removeClass('active');
    $("#description-text").removeClass('hidden');
    $("#material-text").addClass('hidden');
    $("#size-text").addClass('hidden');
    return false;
  });
});

jQuery(function() {
  return $("#material-toggle").click(function() {
    $(this).addClass('active');
    $("#description-toggle").removeClass('active');
    $("#size-toggle").removeClass('active');
    $("#material-text").removeClass('hidden');
    $("#description-text").addClass('hidden');
    $("#size-text").addClass('hidden');
    return false;
  });
});

jQuery(function() {
  return $("#size-toggle").click(function() {
    $(this).addClass('active');
    $("#description-toggle").removeClass('active');
    $("#material-toggle").removeClass('active');
    $("#size-text").removeClass('hidden');
    $("#description-text").addClass('hidden');
    $("#material-text").addClass('hidden');
    return false;
  });
});

jQuery(function($) {
  let attempts = 0
  window.mwInterval = setInterval(() => {
    var $optionsContainer = $('.mw-options-container')
    
    if ( attempts >= 30 || $optionsContainer.children().length > 0 )
      clearInterval(window.mwInterval)

    if ( $optionsContainer.children().length > 0 )
      $('.product').addClass('has-custom-options')
    
    attempts ++
  }, 100)
});
